import { Product } from '../../ReceivementTypes'

export const sortProductsByDescription = (a: Product, b: Product) => {
  if (a.description < b.description) {
    return -1
  }
  if (a.description > b.description) {
    return 1
  }
  return 0
}
